import {Component, Input, OnInit} from '@angular/core';
import {Device} from "../../../classes/device/device";
import {StatesService} from "../../../services/state/states.service";
import {DeviceService} from "../../../services/device/device.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {DeviceChildrenAvalaibleComponent} from "./modals/device-children-avalaible/device-children-avalaible.component";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {ModalService} from '../../../services/modal/modal.service';

@Component({
    selector: 'app-device-children',
    templateUrl: './device-children.component.html',
    styleUrls: ['./device-children.component.css']
})
export class DeviceChildrenComponent implements OnInit {

    @Input('device') device: Device = null;
    @Input('type') type: number = null;
    @Input('typeList') typeList: any[] = null;
    @Input('deviceId') deviceId = null;
    faPlus = faPlus;
    showSpinner: boolean = false;
    visible = true;
    selectable = true;
    removable = true;
    generateLocationPreference = false;

    constructor(private modalService: ModalService,
                public activeModal: NgbActiveModal,
                public statesService: StatesService,
                private deviceService: DeviceService,
                private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
    }

    async openModal() {
        const modalRef = this.modalService.openNgbModal(DeviceChildrenAvalaibleComponent, {size: 'lg'});
        const componentInstance: DeviceChildrenAvalaibleComponent = modalRef.componentInstance;
        componentInstance.deviceTypeName = this.getDeviceType(this.type);
        componentInstance.deviceParent = this.device;
        componentInstance.deviceId = this.deviceId;
        componentInstance.typeChildren = this.type;
        componentInstance.listChannelAvailableByDeviceType = this.getListChannelAvailableByDeviceType(this.type);
        componentInstance.generateLocationPreference = this.generateLocationPreference;
        this.generateLocationPreference = await modalRef.result;
    }

    getDeviceType(typeId: number) {
        let typeD: string = "";
        this.typeList.forEach(type => {
            if (typeId === type.value) typeD = type.name;
        });
        return typeD;
    }

    getListByDeviceType(typeId: number) {
        let newChildren: any[] = [];
        if (this.device.children) {
            this.device.children.forEach(child => {
                if (typeId === child.device_type.id) {
                    newChildren.push(child);
                }
            });
        }
        return newChildren;
    }

    getListChannelAvailableByDeviceType(typeId: number) {

        let listChannel: number[] = [1, 2, 3, 4, 5, 6];

        if (typeId === 2 || typeId === 4) {
            listChannel = [1, 2, 3, 4];
        }

      if (typeId === 12) {
        listChannel = [1, 2, 3];
      }
      if (typeId === 3 && this.device.device_type === 18)  {
        listChannel = [1, 2];
      }
      if (typeId === 16) {
        listChannel = [3];
      }
        if (this.device.children) {
            this.device.children.forEach(child => {
                if (typeId === child.device_type.id) {
                    let index = listChannel.indexOf(child.channel);
                    if (index > -1) listChannel.splice(index, 1);
                }
            });
        }
        return listChannel;

    }

    remove(id: number): void {
        this.showSpinner = true;
        let device = new Device();
        device.parent = null;
        device.channel = null;
        this.deviceService.patchDevice(id, device).subscribe((data: Device) => {
            this.statesService.reloadDeviceCrud.next();
            this.statesService.reloadListDevices.next();
            this.statesService.reloadProjectDevice.next();
            this.toastr.success(id.toString() + ' removed from ' + this.device.uid, this.translate.instant('SUCCESS'));
            this.showSpinner = false;
        })
    }


}


